import apiClient from '@/lib/api/apiClient'
import { extractErrorMessage } from '@/lib/utils/errorHandling'
import type {
  NotificationAction,
  NotificationListParams,
  NotificationSubmitPayload,
} from '../types'

export async function getNotificationActions(
  params: NotificationListParams = {},
): Promise<NotificationAction[]> {
  try {
    const response = await apiClient.get<NotificationAction[]>('/api/action_name_list', { params })
    return response.data ?? []
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to load notification settings')
  }
}

export async function updateNotificationAction(
  anId: number,
  payload: NotificationSubmitPayload,
): Promise<NotificationAction> {
  try {
    const response = await apiClient.post<NotificationAction>(
      `/api/update_action_name/${anId}`,
      payload,
    )
    return response.data
  } catch (error) {
    throw new Error(extractErrorMessage(error) || 'Failed to update notification setting')
  }
}
